import {useQuery} from '@tanstack/react-query';

import {useEventPropertyDefinitions} from 'common/contexts/react/event-property-definition-context';
import {queryClient} from 'common/react-query/query-client';
import {PropertyDefinitionIdentity} from 'common/report/queries/app-api/data-definitions-types';

/**
 * Gets which events a property is on. Doesn't work for custom properties.
 */
export function usePropertyEvents(
  property: PropertyDefinitionIdentity,
  opts?: {
    enabled?: boolean;
  },
) {
  const propertyDefinitionResource = useEventPropertyDefinitions();

  const {data, isPending} = useQuery(
    {
      queryKey: [`propertyEvents`, property],
      queryFn: () => propertyDefinitionResource.getEvents(property),
      // properties dont get added to new events often, so we can hold it for a little bit to reduce data definitions load
      staleTime: 1000 * 60 * 5, // 5 minutes
      enabled: opts?.enabled,
    },
    queryClient,
  );

  return {
    data,
    isPending,
  };
}
